export default __webpack_public_path__ + "static/media/printServer.b9af0cba.PNG";